<osn-cxb-dialog>
  <h1 class="ta-center mb-3">Delete image ?</h1>
  <p class="ta-center mb-4">{{ data || "Without an image you won't be able to save your tray." }}</p>
  <div class="d-flex align-items-center justify-content-center">
    <button class="action-btn secondary mr-4" (click)="onCancelClick()">Cancel</button>
    <button class="action-btn" (click)="onDeleteClick()">Delete</button>
  </div>
</osn-cxb-dialog>
